module.exports = __webpack_public_path__ + "img/varied_one.8132c7ea.png";